import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'stripe/auth/publishable-key';

export const useAccountStripeApiPublicApiKeys = ({
	impersonationContext,
}: {
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();
	return useQuery({
		queryFn: async () => {
			const result = await userSession.webServiceHelper.callAsync<string>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `stripe/auth/publishable-key`,
					impersonationContext,
				}),
				'GET'
			);
			return result;
		},
		queryKey: [BASE_QUERY_KEY],
		refetchOnWindowFocus: false,
	});
};
